import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import styles from './Section.styles.esm.js';

const Section = (_a) => {
    var { inverse = false, className, asChild = false, display, maxWidth } = _a, props = __rest(_a, ["inverse", "className", "asChild", "display", "maxWidth"]);
    const classes = styles({
        display: display,
        maxWidth: maxWidth,
        class: className,
    });
    const Comp = asChild ? Slot : "section";
    return jsx(Comp, Object.assign({ className: classes }, props));
};
Section.displayName = "Section";

export { Section };
